import { UnitAmount } from '@/domain/stripe/quote/model/UnitAmount'
import { UnitAmountPresentation } from '@/domain/stripe/quote/presentation/UnitAmountPresentation'
import type { IUnitAmountPresenter } from '@/domain/stripe/quote/presenter/contract/IUnitAmountPresenter'
import { injectable } from 'inversify'

@injectable()
export class UnitAmountPresenter implements IUnitAmountPresenter {
  public present(quoteUnitAmount: UnitAmount): UnitAmountPresentation {
    return new UnitAmountPresentation(
      quoteUnitAmount.currency,
      quoteUnitAmount.amount,
      quoteUnitAmount.interval,
    )
  }
}
